const AggressorRestriction = {
    options: [
        {value: "HOME_REMOVAL", label: "Afastamento do lar"},
        {value: "VICTIM_APPROACH", label: "Aproximação da vítima"},
        {value: "VICTIM_CONTACT", label: "Contato com a vítima"},
        {value: "SOCIAL_MEDIA", label: "Exposição da vítima em redes sociais"},
        {value: "VICTIM_PLACES", label: "Permanência em locais onde a vítima esteja presente"},
        {value: "FIREARM", label: "Porte ou posse de arma de fogo"},
        {value: "MINOR_CHILDREN", label: "Visitas e contato com filhos menores"},
    ],

    toOption: (value) => {
        if (!value) return [];

        return value.map(v => AggressorRestriction.options.find(option => option.value === v))
    },

    optionsToView: (value) => {
        if (!value) return [];

        return value.map(v => v.label).sort().join(", ")
    }
};

export default AggressorRestriction;
